import styled from '@emotion/styled'
import { typography } from '@resiliatech/birdsong'
import { Typography } from '@mui/material'

export const Header = styled.div`
  margin: 0 8px 12px 8px;
`
export const Title = styled.label`
  display: inline-block;
  margin-bottom: 20px;
  ${typography.up2.semiBoldSans};
`

export const SubTitle = styled(Typography)`
  color: #68737b;
`
